import { useModal } from 'primsell-shared-layer/features'
import { Modal } from '../modal'

import { ModalTypeE } from '../modal/modal.types'
import { IImagePreviewModalState } from './image-preview-modal.types'

import * as S from './image-preview-modal.styles'

const ImagePreviewModal = () => {
  const { modalConfig, closeModal } = useModal<IImagePreviewModalState>()

  return (
    <Modal type={ModalTypeE.FULL_SIZE}>
      <Modal.Content>
        <S.Image src={modalConfig?.state?.src} alt="image-preview" onClick={closeModal} />
      </Modal.Content>
    </Modal>
  )
}

export { ImagePreviewModal }
